module.exports = __webpack_public_path__ + "img/express.811e1a17.svg";